// extracted by css-extract-rspack-plugin
export default {"intro":"OSUL1kLbSXY50RB9","toggleRow":"rsXWqgD9ecUJ5XBi","toggleLabel":"EszUrnDA9fcBtEUd","toggleLabelDisabled":"arBAYsqKP8cSLibJ","savePreference":"hg0MAXSiJgvYkLE4"};